/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_TeamInputs */



/**
* | output |
* | --- |
* | "Team meetings" |
*
* @param {Agenda_Filter_TeamInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_team = /** @type {((inputs?: Agenda_Filter_TeamInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_TeamInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Team meetings")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réunions d’équipe")
	return /** @type {LocalizedString} */ ("Team meetings")
});